import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { LandingPageTeaser } from 'cpie-common';
import { fetchLandingPageTeaser } from './LandingPageTeaserSlice';
import { LandingPageTeaserContentSelector } from './LandingPageTeaserContentSelector';

export function useLandingPageTeaser(): AbstractContentState<LandingPageTeaser> {
    return useCmsContent(fetchLandingPageTeaser, LandingPageTeaserContentSelector);
}
